import React from 'react';
import PropTypes from 'prop-types';

import cx from 'classnames';
import s from './MessageThreadButton.css';


const MessageThreadButton = ({ name, className, handleMsgFormDisplay, handleNewMsgFormDisplay }) => {

  const formClickHandler = () => {
    if (name === 'New') {
      handleNewMsgFormDisplay(name);
    } else {
      handleMsgFormDisplay(name);
    }
  };

  const html = (name === 'New' ? '+' : name);
  // @TODO: NewMsgButton inherits s.component rule in this component. This sucks
  // because we then have to add override properties in the NewMsgButton.css.
  // figure out how to pass a better className value here so we can be
  // rid of override rules.
  return (
    <button
      name={name}
      className={cx(s.component, className)}
      onClick={formClickHandler}
    >
      {html}
    </button>
  );
};

MessageThreadButton.propTypes = {
  name: PropTypes.string,
  className: PropTypes.string,
  handleMsgFormDisplay: PropTypes.func,
  handleNewMsgFormDisplay: PropTypes.func,
};

export default MessageThreadButton;



// WEBPACK FOOTER //
// ./src/components/Pages/Messages/MessageThreadButton/MessageThreadButton.js